/**
 * Created by sunyanzhe on 2018/11/26.
 */
export const selectedData = {
  data: [],
  get type() {
    if (this.data.length > 1) return 'multi'
    if (this.data.length == 0) return ''
    return this.data[0].data.is_dir ? 'folder' : 'file'
  },
  ssoRenderData: {},
  ssoData: {},
  scanRenderData: {},
  scanData: {},
  authRenderData: {},
  authData: {},
  import2RenderData: {},
  import2Data: {},
  import3RenderData: {},
  import3Data: {},
  binding2RenderData: {},
  binding2Data: {},
  binding3RenderData: {},
  binding3Data: {},
  moduleFormatObj: {},
  adLdapInfo: {},
  pluginVersion: {},
  selectedBaseDN: {},
  configGroup: [],
}

export const selectedDataGetters = {
  selectedDataLength: state => state.selectedData.data.length,
  selectedDataType: state => state.selectedData.type,
  selectedNeids: state => state.selectedData.data.map(x => x.neid),
  ssoRenderData: state => state.selectedData.ssoRenderData,
  ssoData: state => state.selectedData.ssoData,
  scanRenderData: state => state.selectedData.scanRenderData,
  scanData: state => state.selectedData.scanData,
  authRenderData: state => state.selectedData.authRenderData,
  authData: state => state.selectedData.authData,
  import2RenderData: state => state.selectedData.import2RenderData,
  import2Data: state => state.selectedData.import2Data,
  import3RenderData: state => state.selectedData.import3RenderData,
  import3Data: state => state.selectedData.import3Data,
  moduleFormatObj: state => state.selectedData.moduleFormatObj,
  adLdapInfo: state => state.selectedData.adLdapInfo,
  pluginVersion: state => state.selectedData.pluginVersion,
  selectedBaseDN: state => state.selectedData.selectedBaseDN,
}

export const selectedDataMutations = {
  selectedDataAdd(state, obj) {
    let data = state.selectedData.data
    for (let i = 0; i < data.length; i++) {
      if (data[i].index == obj.index) {
        data[i] = obj
        return
      }
    }
    state.selectedData.data.push(obj)
  },
  selectedDataRadio(state, obj) {
    state.selectedData.data.splice(0, state.selectedData.data.length)
    state.selectedData.data.push(obj)
  },
  selectedDataDel(state, index) {
    let data = state.selectedData.data
    for (let i = 0; i < data.length; i++) {
      if (data[i].index == index) data.splice(i, 1)
    }
  },
  selectedDataClear(state) {
    state.selectedData.data.splice(0, state.selectedData.data.length)
  },
  setSsoRender(state, data) {
    state.selectedData.ssoRenderData = data
  },
  setSsoData(state, data) {
    state.selectedData.ssoData = data
  },
  setScanRender(state, data) {
    state.selectedData.scanRenderData = data
  },
  setScanData(state, data) {
    state.selectedData.scanData = data
  },
  setAuthRender(state, data) {
    state.selectedData.authRenderData = data
  },
  setAuthData(state, data) {
    state.selectedData.authData = data
  },
  setConfigGroup(state, data) {
    state.selectedData.configGroup = data
  },
  setImport2Render(state, data) {
    state.selectedData.import2RenderData = data
  },
  setImport2Data(state, data) {
    state.selectedData.import2Data = data
  },
  setImport3Render(state, data) {
    state.selectedData.import3RenderData = data
  },
  setImport3Data(state, data) {
    state.selectedData.import3Data = data
  },
  setBinding2Render(state, data) {
    state.selectedData.binding2RenderData = data
  },
  setBinding2Data(state, data) {
    state.selectedData.binding2Data = data
  },
  setBinding3Render(state, data) {
    state.selectedData.binding3RenderData = data
  },
  setBinding3Data(state, data) {
    state.selectedData.binding3Data = data
  },
  setModuleFormatObj(state, data) {
    state.selectedData.moduleFormatObj = data
  },
  setAdLdapInfo(state, data) {
    state.selectedData.adLdapInfo = { ...state.selectedData.adLdapInfo, ...data }
  },
  setSelectedBaseDN(state, data) {
    state.selectedData.selectedBaseDN = data
  },
  setPluginVersion(state, data) {
    state.selectedData.pluginVersion = data
  },
}



// WEBPACK FOOTER //
// ./store/modules/m-get-selectdata.js